import {testIdProps} from '@github-ui/test-id-props'
import {useContainerBreakpoint} from '@github-ui/use-container-breakpoint'
import {useRef} from 'react'

import styles from './filter-container.module.css'

/**
 * Renders a styled div for the `<TokenizedFilterInput />` component
 */
export function FilterContainer({children}: React.PropsWithChildren) {
  const filterContainerRef = useRef<HTMLDivElement>(null)

  // eslint-disable-next-line react-hooks/refs
  const breakpoint = useContainerBreakpoint(filterContainerRef.current)

  return (
    <div
      ref={filterContainerRef}
      role="region"
      aria-label="View filters"
      {...testIdProps('base-filter-input')}
      style={{
        flexWrap: breakpoint(['wrap', 'nowrap']),
        justifyContent: breakpoint(['flex-start', 'space-between']),
      }}
      className={styles.Box}
    >
      {children}
    </div>
  )
}

try{ FilterContainer.displayName ||= 'FilterContainer' } catch {}